<template>
  <div :class="$style['pt-scan-payment-counselor']">
    <pt-page-title :title="pageTitle" isSearch @search="search" @emptySearch="emptySearch" :searchKey="searchKey" @searchNo="searchNo" isParams>
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabelsLb" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <el-button type="primary" @click="exportAllOrder" :loading="exportLoading">导出</el-button>
        <el-button type="primary" @click="exportHistoryAllOrder">导出历史</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
    <pt-scan-payment-counselor-table ref="table" :isLifeExperienceHall="isLifeExperienceHall" :isScanPaymentStorage="isScanPaymentStorage" :tableLabels="tableLabels" :pageSize="pageSize" :paramsData="paramsData" :isFromRouter="isFromRouter">
      <template>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-popover placement="bottom" title="备注" width="200" trigger="focus" :content="scope.row.note" v-model="scope.row.showNote">
              <div class="note-message-class" @click="showNote(scope.row)" slot="reference">
                {{scope.row.note}}
              </div>
            </el-popover>

          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-if="showRefund(scope.row)" @click="refundOrder(scope.row)" :loading="scope.row.refundLoading">退款</el-button>
          </template>
        </el-table-column>
      </template>
    </pt-scan-payment-counselor-table>
  </div>
</template>

<script>
// 组件class前缀
import ptScanPaymentCounselorTable from './pt-scan-payment-counselor-table/withData'
import { filterLabels, tableLabels, filterLabelsOrg, tableLabelsOfLifeExperienceHall, filterLabelsOfLifeExperienceHall } from './payment-counselor'
import { emptyObject } from '@/utils/lifebankUtils'
import { hasPermissions } from 'utils/permissions'
import { cashCount } from '@/utils/formUtils'
import { qrCodeBusinessTypesOfStorage } from 'json/index'
const prefixCls = 'pt-scan-payment-counselor'
/** 是否可退款 */
const PERM_LIFEBANK_SCAN_PAYMENT_MANAGEMENT = 'PERM_LIFEBANK_SCAN_PAYMENT_MANAGEMENT'
/** 是否可查看所有订单，如果有该权限将可筛选分子公司 */
const PERM_LIFEBANK_SCAN_PAYMENT_VIEW_ALL = 'PERM_LIFEBANK_SCAN_PAYMENT_VIEW_ALL'
/** 是否可退款(生命体验馆) */
const PERM_LIFE_EXPERIENCE_HALL_SCAN_PAYMENT_MANAGEMENT = 'PERM_LIFE_EXPERIENCE_HALL_SCAN_PAYMENT_MANAGEMENT'
export default {
  name: 'pt-scan-payment-counselor',
  components: {
    ptScanPaymentCounselorTable
  },
  props: {
    orderOrganization: {
      type: Array,
      default: function () {
        return []
      }
    },
    exportLoading: Boolean,
    isLifeExperienceHall: Boolean,
    isScanPaymentStorage: Boolean
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    },
    page () {
      return this.$refs.table.page
    },
    // 退款权限
    HAS_ORDER_REFUND () {
      return this.$auth.user() && this.$auth.user().permissions &&
        (hasPermissions(this.$auth.user().permissions, PERM_LIFEBANK_SCAN_PAYMENT_MANAGEMENT) || hasPermissions(this.$auth.user().permissions, PERM_LIFE_EXPERIENCE_HALL_SCAN_PAYMENT_MANAGEMENT))
    },
    // 查看全部订单权限
    HAS_VIEW_ALL () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_LIFEBANK_SCAN_PAYMENT_VIEW_ALL)
    },
    filterLabelsLb () {
      let filterLabels = JSON.parse(JSON.stringify(this.filterLabels))
      filterLabels.forEach(item => {
        if (item.value === 'type') {
          this.$set(item, 'options', this.isScanPaymentStorage ? qrCodeBusinessTypesOfStorage : item.options)
        }
      })
      return this.isLifeExperienceHall ? filterLabelsOfLifeExperienceHall : filterLabels
    },
    pageTitle () {
      return this.isScanPaymentStorage ? '静态码收款业务' : (this.isLifeExperienceHall ? '生命体验馆扫码支付' : '生命银行扫码支付')
    },
    tableLabels () {
      return this.isLifeExperienceHall ? tableLabelsOfLifeExperienceHall : tableLabels
    }
  },
  data () {
    return {
      pageSize: 10,
      params: {},
      paramsData: {},
      searchKey: null,
      filterLabels: filterLabels,
      isFromRouter: false
    }
  },
  watch: {
    orderOrganization: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'organizationId') {
            this.$set(item, 'options', val)
          }
        })
      },
      deep: true
    }
  },
  methods: {
    showNote (row) {
      this.$set(row, 'showNote', true)
      row.showNote = true
    },
    noShowNote (row) {
      this.$set(row, 'showNote', false)
      row.showNote = false
    },
    showRefund (row) {
      return row.status === 'COMPLETED' && this.HAS_ORDER_REFUND && !row.refundSuccess
    },
    getTableData () {
      let page = this.$refs.table.page
      this.$refs.table.getTableData(page)
    },
    refundOrder (row) {
      this.$confirm('请确认是否继续退款操作。', '退款确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info' }).then(_ => {
        this.$emit('refundOrder', row)
      })
    },
    downloadCode (row) {

    },
    exportAllOrder () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info' }).then(_ => {
          this.getParamsData()
          this.$emit('exportAllOrder', this.paramsData)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryAllOrder () {
      let url = this.isScanPaymentStorage ? '/export-history/scan-payment-storage?name=static_code_payment_order_export' : (this.isLifeExperienceHall
        ? '/export-history/scan-payment-life-experience-hall?name=life_experience_hall_payment_order_export'
        : '/export-history/scan-payment-counselor?name=consultant_payment_order_export')
      this.$router.push(url)
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.queryParams, 'searchKey')
    },
    search (val) {
      this.$set(this.paramsData, 'searchKey', val)
    },
    searchNo (val) {
      this.searchKey = val
    },
    cleanParams () {
      emptyObject(this.params)
      let businessType
      if (this.paramsData.businessType) {
        businessType = this.paramsData.businessType
      }
      emptyObject(this.paramsData)
      if (businessType) {
        this.paramsData.businessType = businessType
      }
      this.Filter()
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.getParamsData()
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
    },
    getParamsData () {
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'payTime' || key === 'completedTime' || key === 'amout') {
          this.$delete(this.params[key], 'index')
          if (key === 'amout') {
            this.params.amountStart = cashCount(this.params[key].amountStart)
            this.params.amountEnd = cashCount(this.params[key].amountEnd)
            this.$delete(this.params, key)
          }
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      this.paramsData = { ...this.paramsData, ...this.params, searchKey: this.searchKey }
    }
  },
  created () {
    if (this.HAS_VIEW_ALL) {
      let hasOrg = false
      filterLabels.forEach(item => {
        if (item.value === 'organizationId') {
          hasOrg = true
        }
      })
      if (!hasOrg) {
        filterLabels.push({ ...filterLabelsOrg })
      }
    }
    if (this.isLifeExperienceHall) {
      this.paramsData.businessType = 'LIFE_EXPERIENCE_HALL'
    }
    if (this.isScanPaymentStorage) {
      this.paramsData.businessType = ['STORAGE', 'TAI_KANG']
    }
    this.filterLabels = filterLabels
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-scan-payment-counselor{
  :global{
    .note-message-all{
      .note-title{
        text-align: center;
        font-weight: bolder
      }
    }
    .note-message-class{
      white-space: nowrap;
      overflow: hidden;
    }
    .el-button{
      margin-right: 10px;
      & +.el-button{
        margin-left: 0;
      }
    }
  }
}
</style>
